import axios from 'axios';


let baseURL ='http://localhost:5001'
    baseURL = 'https://sistema-consulta-folha-back.ibfc.org.br';
if (process.env.NODE_ENV !== "development")
    baseURL = 'https://sistema-consulta-folha-back.ibfc.org.br';


let axios_instance = axios.create({
    baseURL, // baseURL inicial
    timeout: 15000,
});

export default axios_instance

